import { testFbAuth, testFbId, testFbStorage, apiServerTimestamp } from './index'
import { createDutyObject } from './duties'
import { apiUrl, cloudFunctionsUrl } from '@/constants'
import { valueToTime, valueToDB } from '@/functions'
import { formatDbTime, durationToMinutes } from '@/mixins/utils'
import { isValidGroupImage, sanitizeGroupImage } from '@/functions/groups'
import userProfileBroken from '@/assets/images/user-profile-broken.png'
import { httpRequest/* , sosApi */ } from '@/services/api'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
// API
//

export const apiUpdateScaleTurn = (viewerID, groupID, scaleID, turnID, payload) => httpRequest({ method: 'PATCH', url: `${apiUrl}/turn/${viewerID}/${groupID}/${scaleID}/${turnID}`, payload })

// JESUS: Revisar
// export const apiUpdateScaleTurn = async (groupID, scaleID, turnID, data) => await sosApi.patch(`turn/${groupID}/${scaleID}/${turnID}`, data)

export const apiGetUserIdByEmail = async email => {
  try {
    const response = await fetch(`${cloudFunctionsUrl}/getUserIdByEmail?email=${encodeURIComponent(email)}`)
    const data = response.ok ? await response.json() : null

    return response.ok ? { code: data.code, data: data.data } : { code: 0, data: null }
  } catch (error) {
    return { code: 0, data: error }
  }
}

//
// ?
//

export const apiGetCurrentUser = () => {
  return !!testFbAuth === true && !!testFbAuth.currentUser === true ? testFbAuth.currentUser : false
}

//
// USADO SOMENTE NO duties.js
//

export const apiGetUserId = () => {
  const requesterSession = apiGetCurrentUser()
  return !!requesterSession === true ? requesterSession.uid : false
}

export const apiCheckUserDutyConflictInGroup = async (groupID, userID, selectedDate, selectedTurnTime) => {
  const scales = await getScalesByGroupID(groupID)

  if (scales.length === 0) return []

  const selectedStartTime = formatDbTime(selectedTurnTime) // durationToMinutes(formatDbTime(selectedTurnTime))

  const foundDuties = []

  scales.forEach(([scaleID, scale]) => {
    Object.entries(scale.turnos).forEach(([_, turn]) => {
      const processedStartTime = formatDbTime(turn.hour)

      const turnDuties = !!turn.plantoes === true ? Object.entries(turn.plantoes) : []

      if (selectedStartTime === processedStartTime && turnDuties.length > 0)
      {
        turnDuties.forEach(([dateYmd, date]) => {
          const turnReleasedDates = !!date.users === true ? Object.values(date.users) : []

          if (dateYmd === selectedDate && turnReleasedDates.length > 0)
          {
            const amount = turnReleasedDates.filter(editDuty => !!editDuty.uid === true && editDuty.uid === userID).length

            if (amount > 0) {
              foundDuties.push({ scaleID, scaleName: String(scale.type || '').trim(), duration: formatDbTime(turn.duration), amount })
            }
          }
        })
      }
    })
  })

  return foundDuties
}

export const apiIsUserInDuty = async (groupID, scaleID, turnID, date, userID) => {
  try {
    const s = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}/plantoes/${date}/users`).orderByChild('uid').equalTo(userID).once('value')
    return !!s === true && !!s.val() === true
  } catch (e) {
    return false
  }
}

export const apiGetTurnDutyUsers = async (groupID, scaleID, turnID, date) => {
  const snapshot = await testFbId.ref('escalas' + '/' + groupID + '/' + scaleID + '/' + 'turnos' + '/' + turnID + '/' + 'plantoes' + '/' + date + '/' + 'users').once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const apiGetTurnDays = async (groupID, scaleID, turnID) => {
  /* try {
    turnDays = await testFbId.ref(`escalas/${grupo}/${escala}/turnos/${turno}/days`).once('value').then(snapshot => Promise.resolve(snapshot.val()))
  } catch (e) {
    // console.log({ e })
  } */
  // const snapshot = await testFbId.ref('escalas' + '/' + groupID + '/' + scaleID + '/' + 'turnos' + '/' + turnID + '/' + 'days').once('value')
  const snapshot = await testFbId.ref('escalas' + '/' + groupID + '/' + scaleID + '/' + 'turnos' + '/' + turnID).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

/*  */

export const apiIsUserAdmin = async (userID, groupID) => {
  const snapshot = await testFbId.ref('users/' + userID + '/grupos/' + groupID + '/admin').once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

// export const apiRemoveUserFromGroup = (userId, userName, groupId, customCallback) => {
export const apiRemoveUserFromGroup = (userId, groupId, customCallback) => {
  try {
    var updates = {}

    /* testFbId.ref(`users/${userId}/grupos/`).child(groupId).remove().then(function()
    testFbId.ref(`grupos/${groupId}/users/`).child(userId).remove().then(function() */

    updates['users/' + userId + '/grupos/' + groupId] = null
    updates['grupos/' + groupId + '/users/' + userId] = null

    // console.log('apiRemoveUserFromGroup:', updates)

    testFbId.ref().update(updates,
    error => {
      if (error) {
        customCallback({
          code: 0,
          message: 'Não foi possível remover o usuário. Por favor, tente novamente ou contate nosso suporte.',
          error,
        })
      } else {
        customCallback({
          code: 1,
          message: '',
          error: '',
        })

        // const tipo = admin === true ? "new-admin" : "remove-admin";

        // apiSendGroupMessage(groupId, {
          // uid: userId,
          // tipo,
          // mensagem: (admin === true ? `${userName} tornou-se administrador do grupo` : `${userName} não é mais administrador do grupo`)
        // }, errorCallback, successCallback)
      }
    })
  } catch (e) {
    customCallback({
      code: 0,
      message: 'Não foi possível remover o usuário. Por favor, tente novamente ou contate nosso suporte.',
      error: e,
    })
  }

  /* testFbId.ref(`users/${userId}/grupos/`).child(groupId).remove().then(function()
  {
    testFbId.ref(`grupos/${groupId}/users/`).child(userId).remove().then(function()
    {
      // apiSendGroupMessage(groupId, {
        // uid: userId,
        // tipo: "leave-group",
        // mensagem: `${userName} saiu do grupo`
      // },
      // error => {
        // customCallback({
          // code: 1,
          // message: `${userName} foi removido grupo, mas não foi possível notificar a saída.`,
          // error
        // })
      // },
      // () => {
        // customCallback({
          // code: 1,
          // message: `${userName} foi removido grupo.`,
          // error: ''
        // })
      // })
    })
    .catch(function(error)
    {
      // console.log("Remove failed: " + error.message)
      customCallback({
        code: 0,
        message: 'Não foi possível remover o usuário. Por favor, tente novamente ou contate nosso suporte.',
        error
      })
    })
  })
  .catch(function(error)
  {
    customCallback({
      code: 0,
      message: 'Não foi possível remover o usuário. Por favor, tente novamente ou contate nosso suporte.',
      error
    })
  }) */
}

export const apiMassiveUpdate = (updates, customCallback) => {
  try {
    /* var updates = {}

    updates['users/' + userId + '/grupos/' + groupId] = null
    updates['grupos/' + groupId + '/users/' + userId] = null */

    // console.log('apiMassiveUpdate:', updates)

    testFbId.ref().update(updates,
    error => {
      if (error) {
        customCallback({
          code: 0,
          message: 'Não foi possível atualizar os dados. Por favor, tente novamente ou contate nosso suporte.',
          error,
        })
      } else {
        customCallback({
          code: 1,
          message: '',
          error: '',
        })
      }
    })
  } catch (e) {
    customCallback({
      code: 0,
      message: 'Não foi possível atualizar os dados. Por favor, tente novamente ou contate nosso suporte.',
      error: e,
    })
  }
}

/**
 *
 * DEFINE O NÍVEL DO USUÁRIO DENTRO DO GRUPO
 *
 */

export const apiSetGroupUserLevel = async (groupId, userId, userName, admin, master, users = []) =>
{
  if ((!!users === true && Array.isArray(users) === true) === false) {
    return {
      code: 0,
      message: `Não foi possível ${admin ? 'promover' : 'rebaixar'} o usuário. Por favor, tente novamente ou fale com o nosso suporte.`,
      error: '',
    }
  }

  const messageId = apiGenerateEntityID(`chats/${groupId}/chats`)

  const fullName = !!userName === true && String(userName).trim().length > 0 ? String(userName).trim() : ''
  const firstName = fullName.length > 0 ? fullName.split(' ')[0] : ''

  const updates = {}
  updates[`users/${userId}/grupos/${groupId}/disabledCapabilities`] = null // Jesus: Limpar capacidades ao alterar nível do usuário
  updates[`grupos/${groupId}/users/${userId}/disabledCapabilities`] = null // Jesus: Limpar capacidades ao alterar nível do usuário
  updates[`users/${userId}/grupos/${groupId}/master`] = master || null // Jesus: Apagar do banco quando for false
  updates[`grupos/${groupId}/users/${userId}/master`] = master || null // Jesus: Apagar do banco quando for false
  updates[`users/${userId}/grupos/${groupId}/admin`] = admin
  updates[`grupos/${groupId}/users/${userId}/admin`] = admin
  updates[`chats/${groupId}/chats/${messageId}`] = {
    uid: userId,
    displayName: fullName || 'Sem nome',
    tipo: master ? 'new-master' : (admin ? 'new-admin' : 'remove-admin'),
    // mensagem: `${fullName.length > 0 ? fullName : 'Usuário'} ${admin ? 'tornou-se' : 'não é mais'} administrador do grupo`,
    mensagem: master ? (
      `${fullName.length > 0 ? fullName : 'Usuário'} tornou-se master do grupo`
    ) : (
      admin ? (
        `${fullName.length > 0 ? fullName : 'Usuário'} tornou-se administrador do grupo`
      ) : (
        `${fullName.length > 0 ? fullName : 'Usuário'} não é mais administrador do grupo`
      )
    ),
    timestamp: apiServerTimestamp(),
    // data: apiServerTimestamp()
  }

  if (!admin)
  {
    updates[`grupos/${groupId}/users/${userId}/municipality`] = null

    // Foi rebaixado? Remove usuário dos municípios vinculados a possíveis GESTORES
    users.forEach(u => {
      if (!!u.userMunicipalities === true && !!u.userMunicipalities[userId] === true) {
        updates[`grupos/${groupId}/users/${u.userID}/municipalities/${userId}`] = null
      }
    })
  }

  const update = await (new Promise((resolve, reject) => {
    testFbId.ref().update(updates,
    error => {
      resolve({
        code: error ? 0 : 1,
        message: error ? (
          `Não foi possível ${master || admin ? 'promover' : 'rebaixar'} o usuário. Por favor, tente novamente ou fale com o nosso suporte.`
        ) : (
          master ? (
            firstName.length > 0 ? `Agora ${firstName} é master no grupo.` : 'Agora o usuário é master no grupo.'
          ) : (
            admin ? (
              firstName.length > 0 ? `Agora ${firstName} é administrador no grupo.` : 'Agora o usuário é administrador no grupo.'
            ) : (
              firstName.length > 0 ? `Agora ${firstName} é um usuário comum no grupo.` : 'Agora o usuário é um usuário comum no grupo.'
            )
          )
        ),
        error,
      })
    })
  }))

  return update
}

/**
 *
 * PROCESS DUTIES
 *
 */

export const rgxFirebaseKey = /(([A-Za-z0-9\-_]){10,256})+/

// export const rgxFirebaseKey = /(([A-Za-z0-9\-\_]){10,256})+/

/**
 *
 * FUNCTIONS
 *
 */

export const apiGenerateEntityID = path => {
  const entityKey = testFbId.ref(path).push().key
  return entityKey
}

export const apiGetScaleRef = (groupID, scaleID) => {
  return testFbId.ref('escalas/' + groupID + '/' + scaleID)
}

export const apiGetScale = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID).once('value')
  return snapshot && snapshot.val() ? snapshot.val() : false
}

export const apiGetScaleConsultationDuration = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID + '/tempo_consulta').once('value')
  if (!!snapshot === false) return 0
  return parseInt(snapshot.val() || '0')
}

export const apiGetScaleCode = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID + '/urlcode').once('value')
  return !!snapshot === true && !!snapshot.val() === true ? String(snapshot.val()) : ''
}

export const apiGetGroupCode = async groupID => {
  const snapshot = await testFbId.ref('grupos/' + groupID + '/urlcode').once('value')
  return !!snapshot === true && !!snapshot.val() === true ? String(snapshot.val()) : ''
}

/**
 *
 * RelatorioHoras.vue
 *
 */

export const apiRefOpen = (ref, callback) => {
  ref.on('value', callback)
}

export const apiRefClose = (ref, callback) => {
  ref.off('value', callback)
}

export const apiUpdateScaleTurnValue = async (groupID, scaleID, turnID, value, cCallback) => {
  try {
    testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}/value`).set(value,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível atualizar o valor do turno',
          error: error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'Valor do turno alterado!',
          error: '',
        })
      }
    })
  } catch (e) {
    cCallback({
      code: 0,
      message: 'Não foi possível atualizar o valor do turno',
      error: e,
    })
  }
}

export const apiUpdateTurnDutiesValue = async (groupID, scaleID, turnID, turnHour = false, newValue = 0, month = false, year = false, cCallback = () => {}) => {
  const type = month !== false && year !== false && turnHour !== false ? 'current' : 'all'

  //
  // ?
  //

  const updates = {}

  //
  // ATUALIZA VALOR DO TURNO
  //

  updates[`escalas/${groupID}/${scaleID}/turnos/${turnID}/value`] = newValue

  //
  // LOAD TURN DUTIES
  //

  const turnSnapshot = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}`).once('value')
  const turn = turnSnapshot && turnSnapshot.val() ? turnSnapshot.val() : false

  if (!!turn && !!turn.plantoes)
  {
    const baseMonth = month !== false ? parseInt(month) : ''
    const baseYear = year !== false ? parseInt(year) : ''

    // console.log('::: MONTH/YEAR:', type === 'current' ? `${baseYear}-${baseMonth}-` : 'all')

    Object.entries(turn.plantoes).forEach(([date, dateData]) => {
      const isValid = (type === 'current' && date.indexOf(`${baseYear}-${baseMonth}-`) !== -1) || type === 'all'

      if (isValid) {
        const plantoes = !!dateData && !!dateData.plantoesIDs ? Object.keys(dateData.plantoesIDs) : []
        // const plantoes = !!dateData && dateData.hasOwnProperty('plantoesIDs') ? Object.keys(dateData.plantoesIDs) : []

        if (plantoes.length > 0) {
          plantoes.forEach(plantaoID => {
            updates[`plantoes/${plantaoID}/valor`] = newValue
          })
        }

        // console.log(`::: Plantões do turno "${turnID}" no dia ${date}:`, plantoes)
      }
    })
  }

  //
  // ATUALIZA DADOS NO BANCO

  testFbId.ref().update(updates,
  error => {
    if (error) {
      cCallback({
        code: 0,
        message: '',
        error,
      })
    } else {
      cCallback({
        code: 1,
        message: 'O valor do turno e dos plantões foram alterados!',
        error: '',
      })
    }
  })
}

export const apiCreateShift = async (groupID, scaleID, weekDays, hour, duration, value, name) => {
  const newShiftID = apiGenerateEntityID(`escalas/${groupID}/${scaleID}/turnos`)

  const updates = {
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/grupo`]: groupID,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/escala`]: scaleID,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/days`]: weekDays,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/hour`]: hour,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/duration`]: duration,
    [`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/value`]: value,
  }

  if (name) updates[`escalas/${groupID}/${scaleID}/turnos/${newShiftID}/name`] = name

  // ATUALIZA DADOS NO BANCO

  return new Promise((resolve, reject) => {
    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({ code: 0, title: 'Atenção!', message: 'Não foi possível criar o turno', error })
        } else {
          resolve({ code: 1, title: 'Feito!', message: newShiftID, error: '' })
        }
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', message: 'Não foi possível criar o turno', error: e })
    }
  })
}

//
//
//

export const apiDeleteScaleTurn = async (groupID, scaleID, turnID, cCallback) => {
  // testFbId.ref('escalas/' + this.groupID + '/' + this.scaleID + '/turnos/' + turnID).remove()

  try {
    testFbId.ref(`escalas/${groupID}/${scaleID}/turnos/${turnID}`).set(null,
    error => {
      if (error) {
        cCallback({
          code: 0,
          message: 'Não foi possível excluir o turno',
          error: error,
        })
      } else {
        cCallback({
          code: 1,
          message: 'O turno foi excluído!',
          error: '',
        })
      }
    })
  } catch (e) {
    cCallback({
      code: 0,
      message: 'Não foi possível excluir o turno',
      error: e,
    })
  }
}

//
//
//
//
//
//
//
//
//

export const apiUpdateScaleName = (groupID, scaleID, scaleName) => {
  return new Promise((resolve, reject) => {
    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref(`escalas/${groupID}/${scaleID}/type`).set(scaleName,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: 'Não foi possível atualizar o nome da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: 'Não foi possível atualizar o nome da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
        error: e,
      })
    }
  })
}

export const apiUpdateScale = async args => {
  return new Promise((resolve, reject) => {
    const data = {
      // Nome da escala
      type: args.scaleName,
      // Valor da escala
      value: !!args.scaleValue === true ? args.scaleValue : 0,
      // LOCAL DA ESCALA (SE HOUVER) -> Nome do local (FIXO ou PERSONALIZADO)
      local: args.scaleLocation.name,
      // COMEÇAR SEMANA NA SEGUNDA?
      // startOnMonday: args.startOnMonday,
      // MÁXIMO DE PLANTÕES POR USUÁRIO NESSA ESCALA
      maxshifts: args.scaleMaxShifts,
      // AVAILABLE SHIFTS COLOR
      availableShiftsColor: args.availableShiftsColor,
      // OWNED SHIFTS COLOR
      ownedShiftsColor: args.ownedShiftsColor,

      tempo_consulta: args.scaleConsultationDuration,
      // requirePatient = true (opcional)
      requirePatient: args.requirePatient === '0' ? true : null,
    }

    // LOCAL DA ESCALA (SE HOUVER) -> Identificador do local (Somente FIXO)
    data.placeID = args.scaleLocation.presetLocations && args.scaleLocation.id.length > 0 ? args.scaleLocation.id : null

    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref(`escalas/${args.groupID}/${args.scaleID}`).update(data,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: 'Não foi possível atualizar os detalhes da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: 'Não foi possível atualizar os detalhes da escala. Por favor, tente novamente ou entre em contato com o suporte técnico.',
        error: e,
      })
    }
  })
}

export const apiCreateScale = args => {
  return new Promise((resolve, reject) => {
    const currentUser = apiGetCurrentUser()

    if (!currentUser)
    {
      resolve({
        code: 0,
        response: 'Desculpe, não foi possível criar a escala. Por favor, entre em contato com o suporte técnico.',
        error: 'Usuário deslogado?',
      })
    }
    else
    {
      //
      // MONTA A ESTRUTURA DE DADOS QUE SERÃO INSERIDOS NO FIREBASE DATABASE

      const currentUserUid = currentUser.uid

      // args.groupID, args.scaleName, args.scaleLocation, args.scaleValue, args.scaleMaxShifts, args.startOnMonday

      const scaleID = apiGenerateEntityID('escalas/' + args.groupID)
      const turnA = apiGenerateEntityID('escalas/' + args.groupID + '/' + scaleID + '/turnos')
      const turnB = apiGenerateEntityID('escalas/' + args.groupID + '/' + scaleID + '/turnos')

      var scale = {
        // Criador da escala
        uid: currentUserUid,
        // Nome da escala
        type: args.scaleName,
        // Valor da escala
        value: !!args.scaleValue === true ? args.scaleValue : 0,
        // LOCAL DA ESCALA (SE HOUVER) -> Nome do local (FIXO ou PERSONALIZADO)
        local: args.scaleLocation.name,
        // COMEÇAR SEMANA NA SEGUNDA?
        startOnMonday: args.startOnMonday,
        // MÁXIMO DE PLANTÕES POR USUÁRIO NESSA ESCALA
        maxshifts: args.scaleMaxShifts,
        // AVAILABLE SHIFTS COLOR
        availableShiftsColor: args.availableShiftsColor,
        // OWNED SHIFTS COLOR
        ownedShiftsColor: args.ownedShiftsColor,
        // Turnos
        turnos: {
          [`${turnA}`]: {
            grupo: args.groupID,
            escala: scaleID,
            days: [0, 1, 2, 3, 4, 5, 6],
            hour: 7,
            duration: 12,
            value: 0,
          },
          [`${turnB}`]: {
            grupo: args.groupID,
            escala: scaleID,
            days: [0, 1, 2, 3, 4, 5, 6],
            hour: 19,
            duration: 4,
            value: 0,
          },
        },
        // Código necessário para acessar link público da escala
        urlcode: ((+new Date()) + Math.random() * 1000).toString(36),
      }

      // LOCAL DA ESCALA (SE HOUVER) -> Identificador do local (Somente FIXO)
      if (args.scaleLocation.id.length > 0) {
        scale.placeID = args.scaleLocation.id
      }

      // TEMPO DE CONSULTA
      scale.tempo_consulta = args.scaleConsultationDuration

      if (args.requirePatient === '0') scale.requirePatient = true

      //
      // MONTA OBJETO CONTENDO OS UPDATES

      var updates = {}

      //
      // CRIA ESCALA

      updates['escalas/' + args.groupID + '/' + scaleID] = scale

      //
      // ATUALIZA DADOS NO BANCO

      try {
        testFbId.ref().update(updates,
        error => {
          if (error) {
            resolve({
              code: 0,
              response: 'Desculpe, não foi possível criar a escala. Por favor, entre em contato com o suporte técnico.',
              error,
            })
          } else {
            resolve({
              code: 1,
              response: '',
              error: '',
            })
          }
        })
      } catch (e) {
        resolve({
          code: 0,
          response: 'Desculpe, não foi possível criar a escala. Por favor, entre em contato com o suporte técnico.',
          error: e,
        })
      }
    }
  })
}

//
// NOTA:
// APAGAR ESCALA TEM POTENCIAL PARA ULTRAPASSAR O LIMITE DE UPDATES DO FIREBASE (1000 ?)
//

export const apiDeleteScale = async (groupID, scaleID) => {
  // PLANTÕES DA ESCALA
  const scaleDuties = await testFbId.ref('plantoes').orderByChild('scaleID').equalTo(scaleID).once('value')
  const $fbDuties = scaleDuties && scaleDuties.val() ? scaleDuties.val() : false

  // PLANTÕES SINALIZADOS DA ESCALA
  const flaggedScaleDuties = await testFbId.ref('plantoes_sinalizados').orderByChild('dutyScaleID').equalTo(scaleID).once('value')
  const $fbPlantoesSinalizados = flaggedScaleDuties && flaggedScaleDuties.val() ? flaggedScaleDuties.val() : false

  // LÊ MENSAGENS DO GRUPO
  const groupMessages = await testFbId.ref(`chats/${groupID}/chats`).once('value')
  const $fbGroupMessages = groupMessages && groupMessages.val() ? groupMessages.val() : false

  //
  //

  if ($fbDuties === false && $fbPlantoesSinalizados === false && $fbGroupMessages === false)
  {
    return {
      code: 0,
      response: 'Desculpe, não foi possível apagar a escala. Por favor, entre em contato com o suporte técnico.',
      error: 'Não foi possível ler os dados',
    }
  }
  else
  {
    //
    // ?

    const $fbDutiesKeys = Object.keys($fbDuties)
    const $fbPlantoesSinalizadosKeys = Object.keys($fbPlantoesSinalizados)
    const $fbGroupMessagesKeys = Object.keys($fbGroupMessages)

    //
    // MONTA OBJETO CONTENDO OS UPDATES

    var dutiesToErase = [] // Array

    var updates = {} // Object

    //
    // APAGAR ESCALA

    updates['escalas/' + groupID + '/' + scaleID] = null

    //
    // APAGAR PLANTÕES DA ESCALA

    if ($fbDutiesKeys.length > 0) {
      $fbDutiesKeys.forEach(dutyID => {
        const duty = $fbDuties[dutyID] || false

        if (duty && duty.scaleID) {
          dutiesToErase.push(dutyID)

          // APAGA PLANTÃO
          updates['plantoes/' + dutyID] = null
          // updates['grupos/' + groupID + '/plantoes/' + dutyID] = null

          // APAGA LOG DO PLANTÃO
          updates['logs/plantoes/' + dutyID] = null
        }
      })
    }

    //
    // APAGAR PLANTÕES SINALIZADOS DA ESCALA

    if ($fbPlantoesSinalizadosKeys.length > 0) {
      $fbPlantoesSinalizadosKeys.forEach(plantaoSinalizadoID => {
        const flaggedDuty = $fbPlantoesSinalizados[plantaoSinalizadoID] || false

        if (flaggedDuty && flaggedDuty.dutyScaleID) {
          updates['plantoes_sinalizados/' + plantaoSinalizadoID] = null
          updates['grupos/' + groupID + '/plantoes_sinalizados/' + plantaoSinalizadoID] = null
        }
      })
    }

    //
    // APAGAR MENSAGENS RELACIONADAS AOS PLANTÕES DA ESCALA
    //
    // *** JESUS ESTÁ VIVO ***
    //

    if ($fbGroupMessagesKeys.length > 0) {
      $fbGroupMessagesKeys.forEach(groupMessageID => {
        const groupMessage = $fbGroupMessages[groupMessageID] || false

        if (groupMessage && groupMessage.plantaoID) {
          // VERIFICA SE ESSA MENSAGEM FOI GERADA À PARTIR DE ALGUM PLANTÃO (QUE SERÁ APAGADO)

          if (dutiesToErase.includes(groupMessage.plantaoID) === true) {
            updates['chats/' + groupID + '/chats/' + groupMessageID] = null
          }
        }
      })
    }

    //
    //

    return new Promise((resolve, reject) => {
      //
      // ATUALIZA DADOS NO BANCO

      try {
        testFbId.ref().update(updates,
        error => {
          if (error) {
            resolve({
              code: 0,
              response: 'Desculpe, não foi possível apagar a escala. Por favor, entre em contato com o suporte técnico.',
              error,
            })
          } else {
            resolve({
              code: 1,
              response: '',
              error: '',
            })
          }
        })
      } catch (e) {
        resolve({
          code: 0,
          response: 'Desculpe, não foi possível apagar a escala. Por favor, entre em contato com o suporte técnico.',
          error: e,
        })
      }
    })
  }
}

export const apiRenewScaleLink = async (groupID, scaleID) => {
  const updates = {
    [`escalas/${groupID}/${scaleID}/urlcode`]: ((+new Date()) + Math.random() * 1000).toString(36),
  }

  return new Promise((resolve, reject) => {
    // ATUALIZA DADOS NO BANCO
    const response = 'Desculpe, não foi possível renovar o link da escala. Por favor, entre em contato com o suporte técnico.'
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({ code: error ? 0 : 1, title: error ? 'Atenção!' : 'Sucesso!', response: error ? response : 'O link da escala foi renovado! Agora compartilhe o novo link com os usuários, pois o link antigo foi bloqueado.', error: error || '' })
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', response, error: e })
    }
  })
}

export const apiRenewGroupLink = async groupID => {
  const updates = {
    [`grupos/${groupID}/urlcode`]: ((+new Date()) + Math.random() * 1000).toString(36),
  }

  return new Promise((resolve, reject) => {
    // ATUALIZA DADOS NO BANCO
    const response = 'Desculpe, não foi possível renovar o link do grupo. Por favor, entre em contato com o suporte técnico.'
    try {
      testFbId.ref().update(updates,
      error => {
        resolve({ code: error ? 0 : 1, title: error ? 'Atenção!' : 'Sucesso!', response: error ? response : 'O link do grupo foi renovado! Agora compartilhe o novo link com os usuários, pois o link antigo foi bloqueado.', error: error || '' })
      })
    } catch (e) {
      resolve({ code: 0, title: 'Atenção!', response, error: e })
    }
  })
}

export const fbFullUpdate = object => {
  return new Promise((resolve, reject) => {
    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref().update(object,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: '',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: '',
        error: e,
      })
    }
  })
}

export const apiGetGroupNewWeekChatMessages = async (groupID, firstDayOfWeek) => {
  const snapshot = await testFbId.ref('chats/' + groupID + '/chats').orderByChild('referer').equalTo(firstDayOfWeek).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const apiGetGroupScaleTurns = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref(`escalas/${groupID}/${scaleID}/turnos`).once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

export const getScalesByGroupID = groupID => {
  return new Promise((resolve, reject) => {
    testFbId.ref(`escalas/${groupID}`).once('value').then(snapshot => {
      resolve(snapshot && snapshot.exists() ? Object.entries(snapshot.val()) : [])
    })
    .catch((e) => {
      resolve([])
    })
  })
}

export const getScalesByGroupPlaceID = async (groupID, placeID) => {
  const scalesRequest = await testFbId.ref(`escalas/${groupID}`).orderByChild('placeID').equalTo(placeID).once('value')
  return (scalesRequest && scalesRequest.val()) ? scalesRequest.val() : false
}

export const getScaleByID = async (groupID, scaleID) => {
  const request = await testFbId.ref(`escalas/${groupID}/${scaleID}`).once('value')
  return (request && request.val()) ? request.val() : false
}

export const getGroupByID = async groupID => {
  const groupRequest = await testFbId.ref(`grupos/${groupID}`).once('value')
  return (groupRequest && groupRequest.val()) ? groupRequest.val() : false
}

export const getUserByID = async userID => {
  const userRequest = await testFbId.ref(`users/${userID}`).once('value')
  const user = (userRequest && userRequest.val()) ? userRequest.val() : false

  if (user && typeof user === 'object')
  {
    user.uid = userID
    user.userImage = Object.prototype.hasOwnProperty.call(user, 'img') && String(user.img).indexOf('https://firebasestorage.googleapis.com/') !== -1 ? String(user.img) : userProfileBroken
    user.userName = Object.prototype.hasOwnProperty.call(user, 'nome') ? String(user.nome).trim() : ''
    user.userEmail = Object.prototype.hasOwnProperty.call(user, 'email') ? String(user.email).trim() : ''

    // user.userID = userID // DO APP
    // user.admin = !!group.users[userID].admin // DO APP
  }

  return user
}

export const getUserByUserID = userID => testFbId.ref(`users/${userID}`).once('value').then(x => x.exists() ? x.val() : null).catch(() => null)

export const apiGetUserDetails = async userID => {
  const request = await testFbId.ref(`users/${userID}`).once('value')
  const result = (request && request.val()) ? request.val() : false
  const user = (result && typeof result === 'object') ? result : false

  if (!!user === false) return false

  // && !!eventOwner.nome && eventOwner.nome.trim().length > 0 ? eventOwner.nome.trim() :
  // userImage: !!eventOwner && !!eventOwner.img && this.isValidGroupImage(eventOwner.img) ? eventOwner.img : this.userProfileBroken,

  const isValidImage = !!user && !!user.img && typeof user.img === 'string' && user.img.indexOf('https://firebasestorage.googleapis.com/') !== -1
  const userName = !!user && !!user.nome === true && user.nome.trim().length > 0 ? user.nome.trim() : ''

  return {
    ...user,
    img: isValidImage ? user.img : '',
    nome: userName,
  }
}

export const processGroupParticipantsList = async group => {
  if (!!group === false || (!!group === true && !!group.users === false)) return []

  const userKeys = Object.keys(group.users)

  const usersList = userKeys.length > 0 ? await Promise.all(
    userKeys.map(async userID => await getUserByID(userID)).filter(userID => userID && typeof userID === 'object')
  ) : []

  // if (usersList.length > 0) users = usersList.sort((a, b) => a.nome.localeCompare(b.nome))
  if (usersList.length > 0) usersList.sort((a, b) => a.nome.localeCompare(b.nome))

  return usersList
}

export const getGroupUsers = async groupID => {
  const group = await getGroupByID(groupID)
  const users = await processGroupParticipantsList(group)
  return users
}

/**
 *
 * ?
 *
 */

export const apiUploadGroupImage = async (groupID, groupImage, groupImageType) => {
  return new Promise((resolve, reject) => {
    /* --- REFERÊNCIA --- */
    const storageRef = testFbStorage.ref(`images/groups/${groupID}`)

    /* --- ENVIA --- */
    const uploadTask = storageRef.put(groupImage, { contentType: groupImageType })
    uploadTask.on(
      'state_changed',
      uploadSnapshot => {
        // [24/01/25] const uploadProgress = (uploadSnapshot.bytesTransferred / uploadSnapshot.totalBytes) * 100
        // [24/01/25] console.log(`::: GROUP "${groupID}" -> Upload is ${uploadProgress}% done`)
      },
      uploadError => {
        resolve({
          code: 0,
          response: uploadError,
        })
      },
      () => uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
        resolve({
          code: 1,
          response: downloadURL,
        })
      }),
    )
  })
}

/**
 *
 * ?
 *
 */

export const apiCreateGroup = async obj => {
  const { uid, displayName } = apiGetCurrentUser()

  // Cria o grupo no banco de dados
  const groupID = apiGenerateEntityID('grupos')

  //
  // UPLOAD GROUP IMAGE
  //
  // [Senhor Jesus]
  // - arrow function para resolver bug no THIS: https://stackoverflow.com/questions/53686064/passing-data-in-a-promise-in-vue
  // - VALIDAR SE O ARQUIVO FOI APAGADO OU NÃO PODE SER ACESSADO
  //

  const imageExists = obj.groupImage.loaded && obj.groupImage.file !== null && typeof obj.groupImage.file === 'object'
  const isPlaceholderImage = obj.groupImage.preview && typeof obj.groupImage.preview === 'string' && obj.groupImage.preview.indexOf('data:image/png;base64,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') !== -1

  //

  const uploadedImage = imageExists ? await apiUploadGroupImage(groupID, obj.groupImage.file, obj.groupImage.file.type) : { code: 0 }
  // console.log(`::: CREATE GROUP "${groupID}" -> IMAGE:`, { uploadedImage, imageExists, isPlaceholderImage, preview: obj.groupImage.preview })

  if (imageExists && uploadedImage.code === 0) return { code: 0, response: 'Não foi possível enviar a imagem. Por favor, tente novamente ou fale com o nosso suporte.', error: uploadedImage }

  const groupImageUrl = imageExists && isValidGroupImage(uploadedImage.response) ? sanitizeGroupImage(uploadedImage.response) : ''
  const img = !isPlaceholderImage && groupImageUrl !== '' ? groupImageUrl : ''

  // MONTA ESTRUTURA DO GRUPO

  const newGroupObject = {}

  // ESTRUTURA DO GRUPO
  newGroupObject['grupos/' + groupID] = {
    type: 'public',
    data_atual: new Date().getTime(),

    img,
    nome: obj.groupName,
    des: obj.groupDescription,
    cnpj: obj.groupCnpj,

    fixLocais: obj.presetLocations,
    locais: obj.presetLocations === true && obj.groupLocations.length > 0 ? Object.fromEntries(obj.groupLocations.map((groupLocation, groupLocationIndex) => ([`local_${groupLocationIndex}`, { nome: groupLocation.groupPlaceName }]))) : [],

    allowCreateDuty: obj.allowCreateDuty,
    allowPassDuty: obj.allowPassDuty,
    remindShiftStart: obj.remindShiftStart,
    startShiftOnDayOnly: obj.startShiftOnDayOnly,
    allowPauseDuringShift: obj.allowPauseDuringShift,
    disableShiftStart: obj.disableShiftStart,
    disableShiftEnd: obj.disableShiftEnd,
    hideDutyValue: obj.hideDutyValue,
    hideGroupShiftsTab: obj.hideGroupShiftsTab,

    approvePassDuty: obj.approvePassDuty,
    whoCanAcceptOrRefuse: !!obj.approvePassDuty === true ? obj.whoCanAcceptOrRefuse : null,

    allowDutyCandidates: obj.allowDutyCandidates,
    disablePassToGroupAndUser: obj.disablePassToGroupAndUser,
    disablePassToGroup: obj.disablePassToGroup,
    requireSosPortalAppointmentKeys: obj.requireSosPortalAppointmentKeys,
    sequentialShiftConflicts: obj.sequentialShiftConflicts,
    sequentialShiftConflictsInterval: obj.sequentialShiftConflictsInterval,

    uid,

    users: { [uid]: { master: true, admin: true, enablePush: true } },

    idconvite: ((+new Date()) + Math.random() * 1000).toString(36),
  }

  // Adiciona o criador do grupo dentro do próprio grupo
  newGroupObject['users/' + uid + '/grupos/' + groupID] = { master: true, admin: true, enablePush: true }

  // MONTA A MENSAGEM QUE SERÁ ENVIADA NO CHAT DO GRUPO
  const chatMessageID = apiGenerateEntityID(`chats/${groupID}/chats`)

  newGroupObject['chats/' + groupID + '/chats/' + chatMessageID] = {
    uid,
    displayName,
    tipo: 'new-group',
    mensagem: 'Grupo criado com sucesso! Clique no botão acima para compartilhar o link de convite com seus colegas.',
    timestamp: apiServerTimestamp(),
    data: apiServerTimestamp(),
  }

  // EXECUTA AS INSERÇÕES NO BANCO
  // console.log(`::: CREATE GROUP "${groupID}" -> UPDATE OBJECT:`, newGroupObject)

  return new Promise((resolve, reject) => {
    testFbId.ref().update(newGroupObject, error => {
      resolve({ code: error ? 0 : 1, response: error ? 'Não foi possível criar o grupo. Por favor, tente novamente ou contate nosso suporte.' : 'O grupo foi criado!', groupID, error })
    })
  })
}

/**
 *
 * ?
 *
 */

export const apiAddGroupPlace = async (data, cCallback) => {
  const placeID = apiGenerateEntityID('grupos/' + data.groupID + '/locais') // Gera um novo ID para o plantão

  var updates = {}

  updates['grupos/' + data.groupID + '/fixLocais'] = true
  updates['grupos/' + data.groupID + '/locais/' + placeID] = {
    nome: data.nome,
  }

  //
  // ATUALIZA DADOS NO BANCO

  // console.log('::: apiAddGroupPlace:', updates)

  testFbId.ref().update(updates,
  error => {
    if (error) {
      cCallback({
        code: 0,
        message: '',
        error,
      })
    } else {
      cCallback({
        code: 1,
        message: placeID,
      })
    }
  })
}

export const apiDeleteGroupPlace = async data => {
  const groupScales = await getScalesByGroupPlaceID(data.groupID, data.placeID)

  return new Promise((resolve, reject) => {
    var updates = {}

    //
    // SE O ÚLTIMO LUGAR FOI APAGADO, O GRUPO SE TORNA DO TIPO "LOCAIS LIVRES", SE TEM MAIS DE 1 LOCAL, O GRUPO CONTINUA TENDO LOCAIS PRÉ-DEFINIDOS

    updates['grupos/' + data.groupID + '/fixLocais'] = data.fixLocais

    //
    // APAGA LOCAL

    updates['grupos/' + data.groupID + '/locais/' + data.placeID] = null

    //
    // APAGA O LOCAL DAS ESCALAS

    if (groupScales) {
      Object.keys(groupScales).forEach(groupScaleID => {
        updates['escalas/' + data.groupID + '/' + groupScaleID + '/placeID'] = null
      })
    }

    //
    // ATUALIZA DADOS NO BANCO

    // console.log('::: apiDeleteGroupPlace:', updates)

    /* resolve({
      code: 1,
      response: '',
    }) */

    try {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: '',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: 'Não foi possível apagar o lugar. Por favor, tente novamente ou entre em contato com o suporte técnico.',
        error: e,
      })
    }
  })
}

/**
 *
 * ?
 *
 */

const dateToNumber = date => {
  const d = date.split('-')

  // [0] = YEAR / [1] = MONTH / [2] = DAY
  d[1] = String(d[1]).padStart(2, '0')
  d[2] = String(d[2]).padStart(2, '0')

  return parseInt(d.join(''))
}

const getWorkingDays = (weeks = [], diasDoTurno = [], dataSemZero, jornada, journeyWorkingDays, journeyDaysOff) => {
  //
  // LÊ OS DIAS DA SEMANA QUE FAZEM PARTE DO TURNO (QUE O USUÁRIO ESTÁ SENDO INSERIDO)
  //

  const valoresDosDiasDoTurno = Object.values(diasDoTurno)

  // console.log('::: getWorkingDays => DIAS DA SEMANA QUE FAZEM PARTE DO TURNO:', diasDoTurno, valoresDosDiasDoTurno)

  //
  // LÊ OS DIAS DO PERÍODO SELECIONADO. EXEMPLO: Janeiro de 2022
  //

  let dates = []

  weeks.forEach(week => {
    week.value.forEach(weekDay => {
      dates.push({ isReleasedWeek: week.isReleasedWeek, dataSemZero: weekDay.dayFmtWzero })
    })
  })

  //
  // FILTRA OS DIAS QUE:
  // - Vem depois do dia selecionado
  // - Fazem parte da jornada selecionada
  // - Fazem parte do turno selecionado
  //

  const selectedDate = dateToNumber(dataSemZero)

  dates = dates.filter(date => dateToNumber(date.dataSemZero) >= selectedDate)

  // console.log(`::: getWorkingDays => PROCESSAR DATAS À PARTIR DO DIA ${dataSemZero} (${selectedDate})`)

  //
  // DEFINE O INTERVALO ENTRE "DIAS TRABALHÁVEIS" E "DIAS DE DESCANSO" CONFORME A JORNADA SELECIONADA
  //

  let workingDays = 0 // keep
  let restingDays = 0 // skip

  if (jornada === '12x36') { workingDays = 1; restingDays = 1 } // SIM, NÃO, SIM...
  if (jornada === '12x48') { workingDays = 1; restingDays = 2 } // SIM, NÃO, NÃO, SIM...
  if (jornada === '12x72') { workingDays = 1; restingDays = 3 } // SIM, NÃO, NÃO, NÃO, SIM...
  if (jornada === 'Semanal') { workingDays = 1; restingDays = 6 } // SIM, NÃO, NÃO, NÃO, NÃO, NÃO, NÃO, SIM...
  if (jornada === '5x2') { workingDays = 5; restingDays = 2 } // ?
  if (jornada === '6x1') { workingDays = 6; restingDays = 1 } // ?
  if (jornada === 'Personalizado') { workingDays = Number(journeyWorkingDays); restingDays = Number(journeyDaysOff) }

  if (workingDays > 0 && restingDays > 0) dates = dates.filter((_, index) => (index % (workingDays + restingDays)) < workingDays)

  // console.log(`::: getWorkingDays => JORNADA ${jornada}: UM PLANTÃO DURANTE ${workingDays} DIA(S) COM INTERVALO DE ${restingDays} DIA(S)`)

  //
  // SELECIONA OS DIAS QUE FAZEM PARTE DO TURNO SELECIONADO
  //
  // SENHOR JESUS - testar moment updateLocale
  //

  if (diasDoTurno.length !== 7)
  {
    dates = dates.filter(date => {
      const dateDay = moment(date.dataSemZero, 'YYYY-M-D').day()
      return valoresDosDiasDoTurno.some(turnDay => turnDay === dateDay) // dayExistsInTurn
    })
  }

  // console.log(`::: getWorkingDays => DIAS QUE FAZEM PARTE DO TURNO E ESTÃO DENTRO DA JORNADA ${jornada}:`, dates)

  //
  // OUTPUT
  //

  return dates
}

//
//
//
// CREATE SHIFT
//
//
//

const addScaleShift = (args = {
  scaleConsultationDuration: false,

  user: { availableTurn: true },
  userScaleHourlyRate: 0,
  //
  //
  //
  //
  turnID: '',
  dataSemZero: '', // YYYY-M-D
  turnoDados: null,
  groupID: '',
  scaleID: '',
  grupoNome: '',
  scaleName: '',
  scaleLocation: '',
  createShift: false,
}) => {
  const isAvailableShift = !!args.user.availableTurn === true
  const dataSemZero = args.dataSemZero.split('-')
  const yyyymd = `${dataSemZero[0]}-${dataSemZero[1]}-${dataSemZero[2]}`
  const ddmmyyyy = `${dataSemZero[2].padStart(2, '0')}/${dataSemZero[1].padStart(2, '0')}/${dataSemZero[0]}`

  // console.log(`::: addScaleShift => DIA SELECIONADO ${ddmmyyyy} (${yyyymd}) EM UMA SEMANA ${args.createShift ? 'JÁ DISPARADA' : 'NÃO DISPARADA'}:`, args)

  let firebasePaths = {}

  //
  // COLOCA PLANTÃO NO EDITAR ESCALA
  //

  const dbRefDate = `escalas/${args.groupID}/${args.scaleID}/turnos/${args.turnID}/plantoes/${yyyymd}/users`
  const refKey = apiGenerateEntityID(dbRefDate)
  const dbReferenceID = `${dbRefDate}/${refKey}`

  firebasePaths = { [dbReferenceID]: args.user }

  //
  // CRIA PLANTÃO
  //

  if (args.createShift)
  {
    // testar - SENHOR JESUS
    const datetime = [parseInt(dataSemZero[0]), parseInt(dataSemZero[1]) - 1, parseInt(dataSemZero[2]), 0, 0, 0, 0]
    const dutyStartDate = moment.utc(datetime).unix() * 1000

    const dutyDuration = valueToDB(args.turnoDados.duration)

    const turnValue = !!args.turnoDados.value === true ? args.turnoDados.value : 0

    const dutyDurationHHMM = formatDbTime(args.turnoDados.duration)

    // ---------------------------------------------------------------------------------
    let dutyValueBasedOnUserScaleHourlyRate = 0
    if (!!args.userScaleHourlyRate === true && args.userScaleHourlyRate >= 1.00)
    {
      // Duração do plantão em minutos
      const totalMinutes = durationToMinutes(dutyDurationHHMM) // Ex: 2 horas e 30 minutos = 150 minutos
      // Calcula o novo valor do plantão com base na duração e no valor por hora
      const newDutyValue = (totalMinutes / 60) * args.userScaleHourlyRate // Valor proporcional
      // Formata o valor com duas casas decimais
      dutyValueBasedOnUserScaleHourlyRate = parseFloat(newDutyValue.toFixed(2))
    }
    // ---------------------------------------------------------------------------------

    const pathShiftDate = `escalas/${args.groupID}/${args.scaleID}/turnos/${args.turnID}/plantoes/${yyyymd}`

    var loggedUser = apiGetCurrentUser()

    const newDutyObject = createDutyObject({
      scaleConsultationDuration: args.scaleConsultationDuration,

      dutyGroupID: args.groupID, // *
      dutyScaleID: args.scaleID, // *
      dutyCreatorID: loggedUser.uid, // *
      dutyOwnerID: isAvailableShift ? 0 : args.user.uid, // *

      dutyMessageDate: ddmmyyyy, // `${dutyDateSplit[0]}/${dutyDateSplit[1]}/${dutyDateSplit[2]}`,
      dataInicioFmt: yyyymd, // dutyDate,

      dutyStartDate, // *
      dutyStartTime: valueToTime(args.turnoDados.hour), // *
      dutyDuration, // *

      dutyName: args.scaleName,
      dutyLocal: args.scaleLocation.name, // *

      dutyValue: turnValue || dutyValueBasedOnUserScaleHourlyRate,

      preventAvailableDutyNotification: false, // notificar plantão do tipo disponível
      // isUserDuty: isAvailableShift ? false : true, // *
      isUserDuty: isAvailableShift === false, // *
      updateGroup: true,
      turnPath: pathShiftDate,

      dutyCreatorName: loggedUser.displayName,
      dutyGroupName: args.grupoNome,
    })

    firebasePaths = {
      ...firebasePaths,
      ...newDutyObject,
    }

    firebasePaths[pathShiftDate + '/confirmedDutys'] = true
  }

  //
  // OUTPUT
  //

  return {
    firebasePaths,
    path: dbReferenceID,
  }
}

export const createShift = async (args = {
  scaleConsultationDuration: false,

  user: { availableTurn: true },
  userScaleHourlyRate: 0,
  weeks: [],
  jornada: '',
  journeyWorkingDays: '',
  journeyDaysOff: '',
  turnID: '',
  dataSemZero: '', // YYYY-M-D
  turnoDados: null,
  groupID: '',
  scaleID: '',
  grupoNome: '',
  scaleName: '',
  scaleLocation: '',
  //
}) => {
  // console.log('::: createShift => args:', args)

  let firebasePaths = {}
  const references = []
  const datesOutput = []

  //
  // Manual
  //

  if (args.jornada === 'Manual')
  {
    const isReleasedWeek = args.weeks.some(week => week.value.some(weekDay => weekDay.dayFmtWzero === args.dataSemZero) && week.isReleasedWeek)

    const added = addScaleShift({ ...args, createShift: isReleasedWeek })

    firebasePaths = added.firebasePaths

    if (!isReleasedWeek) references.push(added.path)

    datesOutput.push(args.dataSemZero)
  }

  //
  // Jornada
  //

  else
  {
    // LÊ OS DIAS DA SEMANA QUE FAZEM PARTE DO TURNO (QUE O USUÁRIO ESTÁ SENDO INSERIDO)
    const detalhesDoTurno = await apiGetTurnDays(args.groupID, args.scaleID, args.turnID)
    const diasDoTurno = !!detalhesDoTurno && !!detalhesDoTurno.days && Array.isArray(detalhesDoTurno.days) ? detalhesDoTurno.days : []

    if (diasDoTurno.length === 0) return { code: 0, firebasePaths: null, references: [], dates: [] }

    // DATAS PARA INSERÇÃO CONFORME A JORNADA SELECIONADA
    const dates = getWorkingDays(args.weeks, diasDoTurno, args.dataSemZero, args.jornada, args.journeyWorkingDays, args.journeyDaysOff)

    // DATABASE PATH'S
    dates.forEach(date => {
      const addedDate = addScaleShift({ ...args, dataSemZero: date.dataSemZero, createShift: date.isReleasedWeek })

      firebasePaths = { ...firebasePaths, ...addedDate.firebasePaths }

      if (!date.isReleasedWeek) references.push(addedDate.path)

      datesOutput.push(date.dataSemZero)
    })
  }

  //
  // OUTPUT
  //

  return { code: 1, firebasePaths, references, dates: datesOutput }
}

/**
 *
 * DEFINE O USUÁRIO (DENTRO DO GRUPO) COMO MUNICÍPIO OU NÃO
 *
 */

export const apiSetUserAsMunicipality = (groupId, userId, municipality, users = []) =>
{
  if ((!!users === true && Array.isArray(users) === true) === false) {
    return {
      code: 0,
      message: `Não foi possível ${municipality ? 'marcar' : 'desmarcar'} o usuário como município. Por favor, tente novamente ou fale com o nosso suporte.`,
      error: '',
    }
  }

  const updates = {
    [`users/${userId}/grupos/${groupId}/municipality`]: municipality || null,
    [`grupos/${groupId}/users/${userId}/municipality`]: municipality || null,
  }

  if (!municipality && users.length > 0)
  {
    // Não é mais um município? Remove usuário dos municípios vinculados a possíveis GESTORES
    users.forEach(u => {
      if (!!u.userMunicipalities === true && !!u.userMunicipalities[userId] === true) {
        updates[`grupos/${groupId}/users/${u.userID}/municipalities/${userId}`] = null
      }
    })
  }

  return new Promise((resolve, reject) => {
    testFbId.ref().update(updates,
    error => {
      resolve({
        code: error ? 0 : 1,
        message: error ? `Não foi possível ${municipality ? 'marcar' : 'desmarcar'} o usuário como município. Por favor, tente novamente ou fale com o nosso suporte.` : '',
        error,
      })
    })
  })
}
